import React, {useEffect, useRef, useState} from 'react';
import {withRouter} from "../../../../utils/services/with-router";
import {connect} from "react-redux";
import ProductCard from "../../../../shared/components/productCard/ProductCard";
import RequestCard from "./ReceivedRequestCard";
import {Flex, Skeleton} from "antd";
import { getReceivedBorrowRequest} from "../../actions/Cartable.action";
import {RequestListProps} from "../../models/RequestListProps";
import moment from 'jalali-moment';
import {useParams} from "react-router-dom";
import BorrowRequestPopup from "../borrowRequestPoup/BorrowRequestPopup";
import {EmptyMessage} from "../../../../shared";
import {StyledButton} from "../../pages/borrowRequest/BorrowRequestList.styled";

const ReceivedRequestList = ({getReceivedBorrowRequest}:RequestListProps) => {
    const [openPopup, setOpenPopup] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)
    const [clickedCardData, setClickedCardData] = useState<any>()
    const [filterType, setFilterType] = useState<string>("1")

    const [requests, setRequests] = useState<any>([])
    const { requestId } = useParams(); // Get the ID from the URL
    const itemRefs = useRef<Record<string, HTMLDivElement | null>>({});

    // Scroll to the item after data is loaded
    useEffect(() => {
        if (requestId && itemRefs.current[requestId]) {
            // @ts-ignore
            itemRefs.current[requestId].scrollIntoView({ behavior: "smooth", block: "center" });
        }
    }, [requestId, requests]);
    const _getBorrowRequest = () => {
        setLoading(true)
        let model = {
            type : filterType
        }
        getReceivedBorrowRequest(model)
            .then((data: any) => {
                setLoading(false)
                if (data.payload != undefined) {
                    setRequests(data.payload.data);
                }
            })
            .catch((e: any) => {
            });
    };
    useEffect(() => {
        _getBorrowRequest()
    }, [filterType]);
    const onCansel = () => {
        setOpenPopup(false)
    }

    return (
     <Flex gap={"small"} vertical>
          <Flex gap={"small"}>
             <StyledButton size={"small"} type={filterType === "1" ? "primary" : "default"} onClick={() => setFilterType("1")}>همه</StyledButton>
             <StyledButton size={"small"} type={filterType === "2" ? "primary" : "default"} onClick={() => setFilterType("2")}>درخواست های ارسالی </StyledButton>
             <StyledButton size={"small"} type={filterType === "3" ? "primary" : "default"} onClick={() => setFilterType("3")}>درخواست های دریافتی</StyledButton>
         </Flex>
         {(requests?.length === 0 && !loading) && <EmptyMessage message={"سفارشی در حال حاضر موجود نیست !"}/>}

         {loading ?<Flex vertical >
                 <Skeleton round active avatar={{shape: "square" }} />
                 <Skeleton round active avatar={{shape: "square"}} />
                 <Skeleton round active avatar={{shape: "square"}} />
             </Flex> :

                 requests.map((item: any) =>
                     <div key={item.id}
                          ref={(el) => (itemRefs.current[item.id] = el)}>
                         <RequestCard onCardClickHandle={(data: any) => {
                             setClickedCardData(data)
                             setOpenPopup(true)
                         }} data={item}/>
                     </div>
                 )

         }

          {openPopup && <BorrowRequestPopup data={clickedCardData} open={openPopup} onCanselHandel={() => onCansel()}/>}
     </Flex>
    );
};


export default connect(null, {getReceivedBorrowRequest})(
    withRouter(ReceivedRequestList)
);
